var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tab-detail" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("youtubeChannel.videos"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header-actions" },
        [
          _c(
            "a-button",
            {
              attrs: { type: "primary", loading: _vm.syncing },
              on: { click: _vm.syncVideos },
            },
            [
              _c(
                "span",
                {
                  staticClass: "material-icons",
                  staticStyle: { "font-size": "16px", "margin-right": "4px" },
                },
                [_vm._v("sync")]
              ),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("youtubeChannel.sync")) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-button",
            { attrs: { loading: _vm.loading }, on: { click: _vm.fetchVideos } },
            [
              _c("a-icon", { attrs: { type: "reload" } }),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("youtubeChannel.refresh")) +
                  "\n            "
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    !_vm.loading
      ? _c(
          "div",
          { staticClass: "videos-container" },
          _vm._l(_vm.videos, function (video) {
            return _c(
              "div",
              {
                key: video.videoId,
                staticClass: "video-card",
                on: {
                  click: function ($event) {
                    return _vm.openVideoDetail(video)
                  },
                },
              },
              [
                _c("div", { staticClass: "thumbnail" }, [
                  _c("img", {
                    attrs: {
                      src: video.thumbnail || video.thumbnailHigh,
                      alt: video.title,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "comment-count" },
                    [
                      _c("a-icon", { attrs: { type: "message" } }),
                      _vm._v(
                        " " +
                          _vm._s(video.commentCount || 0) +
                          "\n                "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(0, true),
                  _vm._v(" "),
                  video.duration
                    ? _c("span", { staticClass: "duration" }, [
                        _vm._v(_vm._s(_vm.formatDuration(video.duration))),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info" }, [
                  _c("h3", { staticClass: "video-title" }, [
                    _vm._v(_vm._s(video.title)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "meta" }, [
                    _c(
                      "span",
                      [
                        _c("a-icon", { attrs: { type: "eye" } }),
                        _vm._v(" " + _vm._s(_vm.formatNumber(video.viewCount))),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      [
                        _c("a-icon", { attrs: { type: "like" } }),
                        _vm._v(" " + _vm._s(_vm.formatNumber(video.likeCount))),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      [
                        _c("a-icon", { attrs: { type: "calendar" } }),
                        _vm._v(" " + _vm._s(_vm.formatDate(video.publishedAt))),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]
            )
          }),
          0
        )
      : _c("div", { staticClass: "loading" }, [_c("a-spin")], 1),
    _vm._v(" "),
    !_vm.loading && _vm.videos.length === 0
      ? _c(
          "div",
          { staticClass: "empty" },
          [
            _c("a-empty", {
              attrs: { description: _vm.$t("youtubeChannel.noVideosFound") },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.totalPages > 1
      ? _c(
          "div",
          { staticClass: "pagination" },
          [
            _c("a-pagination", {
              attrs: {
                current: _vm.page,
                total: _vm.total,
                "page-size": _vm.limit,
              },
              on: { change: _vm.onPageChange },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "play-overlay" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("play_circle")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }